import React, { PureComponent } from 'react';
import { withRouter } from "react-router-dom";
import { fade, makeStyles, useTheme } from "@material-ui/core/styles";

import { Col, Container, Row, Button, ButtonGroup, ButtonToolbar, Card, CardBody, } from 'reactstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LatestListings from './components/LatestListings';
import TopAgents from './components/TopAgents';
import RefinanceClosings from './components/RefinanceClosings';



const TrendsDashboard = (props) => {
	const { t, rtl } = props;	 
	 const section = props.match.params.section ? props.match.params.section : 'broker-blasts';
	
	 return( 
	 	<Container className="dashboard">
	    <Row>
	      <Col md={6}>
	        <h3 className="page-title">
	        	{section === 'broker-outreach' && <span>Broker Outreach</span>} 
	        	{section === 'owner-outreach' && <span>Owner Outreach</span>} 
	        	{section === 'listings' && <span>Recent Listings</span>} 
	        	</h3>
				<h3 className="page-subhead subhead">
				{section === 'broker-outreach' && <span>Target the right agents to promote your properties</span>} 
				{section === 'owner-outreach' && <span>Secure more listings by reaching property owners who are ready to transact</span>} 
				{section === 'listings' && <span>Recent Listings</span>} 
					
					
				  </h3>
	      </Col>
	      <Col md={6}>
		   {/*   	<ButtonToolbar>
		          <ButtonGroup className="btn-group--justified" dir="ltr">
		            <Button color={type === 'all' ? "primary" : "secondary"} onClick={() => this.setState({ type: 'all' })}>All Areas</Button>
		            <Button style={{ marginLeft:1 }} color={type === 'lmi-high' ? "primary" : "secondary"} onClick={() => this.setState({ type: 'lmi-high' })}>Mid & Upper Income</Button>
		            <Button style={{ marginLeft:1 }} color={type === 'lmi' ? "primary" : "secondary"} onClick={() => this.setState({ type: 'lmi' })}>Low & Mod Income</Button>
		            
		          </ButtonGroup>
		        </ButtonToolbar>*/}
		   </Col>
	    </Row>
		
	    {section === 'broker-outreach' && (<Row>
	      <TopAgents type={"all"} />
	    </Row>)}
	    {section === 'owner-outreach' && (<Row>
	      <RefinanceClosings lmi type={"all"}   />
	    </Row>)}
	    {section === 'listings' && (<Row>
	      <LatestListings lmi  type={"all"}  />
	    </Row>)}
	  </Container> 
	  );

}

export default compose(withTranslation('common'), connect(state => ({
  rtl: state.rtl,
})))(withRouter(TrendsDashboard));
